<template>
  <div class="intake-modal">
    <div :class="['intake-page', { 'intake-page--full-screen': fullScreen }]">
      <CalicoProgressBar
        v-if="progresses.length && current && !loadingProgress"
        :current="current"
        :steps="progresses"
        @back="back"
      />
      <div :class="['intake-content', { 'intake-content--full-screen': fullScreen }]">
        <div
          v-if="error"
          class="banner-container"
        >
          <CalicoBanner
            variant="error"
            fixed
          >
            {{ error }}
          </CalicoBanner>
        </div>
        <CalicoLoader v-if="loading || loadingProgress" />
        <slot
          v-else
          :name="progresses[current]?.route.replace(/^\/+/, '').replace(/\//g, '-')"
        />
      </div>
    </div>
    <div
      v-if="footer"
      class="intake-footer"
    >
      <div style="width: fit-content;">
        <button
          class="button-primary label--large"
          :disabled="loading || loadingProgress"
          @click="save"
        >
          Save & Continue
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CalicoBanner from "@/components/calico/banner/index.vue";
import CalicoLoader from '@/components/calico/loader/index.vue';
import CalicoProgressBar from "@/components/pattern/progressBar/index.vue";
import { useForm } from 'vee-validate'
import service from "@/services/index.js";
import services from '@/services/index.js';

export default {
    name: "ModalIntake",
    components: {
        CalicoBanner,
        CalicoLoader,
        CalicoProgressBar
    },
    props: {
        userId: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: ""
        },
        formData: {
            type: Object,
            default: () => ({})
        },
        error: {
            type: String,
            default: ''
        },
        footer: {
            type: Boolean,
            default: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        fullScreen: {
          type: Boolean,
          default: false
        }
    },
    setup() {
      const { validate } = useForm({
        validateOnMount: false,
      })
      return { validate }
    },
    data() {
        return {
            loadingProgress: true,
            current: 0,
            progresses: []
        }
    },
    async mounted() {
        await this.loadProgress()
        this.loadingProgress = false
    },
    methods: {
        async save() {
            const result = await this.validate();
            if (!result.valid) return;

            const next = this.progresses[this.current + 1]
            if (this.$attrs.onSave) {
                await new Promise((resolve) => this.$emit('save', resolve))
            }
            this.loadingProgress = true
            let currentProgress = this.progresses[this.current]
            if (currentProgress?.id) {
              await services.progress.complete(currentProgress.id)
            }
            if (next) {
                await this.loadProgress()
                await this.$router.push({
                  path: next.route,
                  query: this.$route.query
                });
            }
            this.loadingProgress = false
        },
        async loadProgress () {
            this.progresses = await service.progress.get(this.type);
            this.current = this.progresses.findIndex((progress) => progress.route === location.pathname)
            this.$emit('progress', this.progresses)
        },
        async complete(progressId) {
            await service.progress.complete(progressId)
        },
        async back() {
            this.loadingProgress = true
            this.$emit('back')
            if (this.progresses[this.current - 1]) {
                this.$router.push({
                  path: this.progresses[this.current - 1].route,
                  query: this.$route.query
                });
                await this.loadProgress()
            }
            this.loadingProgress = false
        },
    },
};
</script>

<style scoped lang="scss">
.intake-modal {
  @include stack-space($space-none);
  height: 100%;
  background-color: $color-background-secondary;
  align-items: center;
  overflow: auto;

  .intake-page {
    @include stack-space($space-none);
    height: 100%;
    width: 100%;
    max-width: $large-screen-max-width;
    overflow: auto;
    scrollbar-width: none;

    .intake-content {
      @include stack-space($space-large);
      @include inset-space($space-large);
      max-height: 100%;
      width: 100%;
      overflow: auto;
      max-width: $tablet-breakpoint-min-width;

      &.intake-content--full-screen {
        max-width: 100%;
      }
      .banner-container {
        display: flex;
        @include inset-space($space-medium);
        justify-content: center;
        .calico-banner {
          max-width: $tablet-breakpoint-min-width;
        }
      }
    }

    &.intake-page--full-screen{
      max-width: 100%;
    }
  }

  .intake-footer {
    @include stack-space($space-medium);
    @include inset-space($space-large);
    width: 100%;
    align-items: center;
    background: $color-white;
    label {
      color: $color-text-secondary;
      font-weight: $font-weight-bold;
    }
  }
}
</style>